$(document).ready(function(){
$('.cstm_checkout').click(function(e){
  e.preventDefault();
  var total_price = $('.cart__item-sub.total_cart').find('.pre-money .money').text();
  var numeric_value = parseFloat(total_price.replace(/[^\d.]/g, ''));
  if (numeric_value < 149) {
    $(".add_more_money").css("display", "block").delay(2000).fadeOut(400);
}
  else{
     $(".add_more_money").css("display", "none");
   window.location.href = '/checkout';
  }
});
});
// for slider 
document.addEventListener("DOMContentLoaded", function() {
  if (window.innerWidth <= 768) {
    const SlideshowWrapper = document.querySelectorAll('.slideshow_layout');
    var flkty ;
    SlideshowWrapper.forEach((item)=>{
    flkty = new Flickity(item, {        
      autoPlay: true,
      draggable: true,
      contain: true    
    });
    })
   
  }
});
// for search bar  placeholder
 let staticPlaceholder = "Search for ";
  let searcharray = [
    "Fashion Fabrics",
    "Embroideries",
    "Fashion Knits",
    "Prints",
    "Silk",
    "New Arrivals",
    "Swatch Box",
    "Spring Summer"
  ];
  let dynamicPlaceholder = "";
  let searchPlaceholderIndex = 0;
  let offset = 0;
  let len = searcharray.length;
  let forwards = true;
  let skip_count = 0;
  let skip_delay = 15;
  let speed = 100;
  function type() {
    setInterval(function() {
      if (forwards) {
        if (offset >= searcharray[searchPlaceholderIndex].length) {
          ++ skip_count;
          if (skip_count == skip_delay) {
            forwards = false;
            skip_count = 0;
          }
        }
      } else {
        if (offset == 0) {
          forwards = true;
          searchPlaceholderIndex++;
          offset = 0;
          if (searchPlaceholderIndex >= len) {
            searchPlaceholderIndex = 0;
          }
        }
      }
      dynamicPlaceholder = searcharray[searchPlaceholderIndex].substr(0, offset);
      if (skip_count == 0) {
        if (forwards) {
          offset++;
        } else {
          offset--;
        }
      }
      document.querySelectorAll('.search__input').forEach(search_el => {
        search_el.setAttribute("placeholder", staticPlaceholder + dynamicPlaceholder);
      });
    }, speed);
  };
  type();

  document.querySelectorAll('.search__input').forEach(search_el => {
    search_el.addEventListener('input', function() {
      const searchTerm = this.value.toLowerCase();
      const filteredCollections = searcharray.filter(collection => collection.toLowerCase().includes(searchTerm));
      const resultsContainer = document.getElementById('predictive-search');
      resultsContainer.innerHTML = ''; 
      filteredCollections.forEach(collection => {
        const div = document.createElement('div');
        div.textContent = collection;
        resultsContainer.appendChild(div);
      });
    });
  });


$('body').on('click', '.cart__remove', async function (e) {
    e.preventDefault(); // Prevent the default action of the anchor tag
    let variant_id = this.firstElementChild.getAttribute("id")
    let formdata = {
        'id': variant_id,
        'quantity': 0
    };
    let res = await fetch('/cart/change.js', {
        method: "POST",
        headers: {
            'Content-Type': "application/json"
        },
        body: JSON.stringify(formdata)
    })
    if (res.ok) {
        $(this).parents('.product-grid-item').addClass('added-to-cart');
        var cart = JSON.parse(localStorage.getItem('cart')) || [];
        cart.push(variant_id);
        localStorage.setItem('cart', JSON.stringify(cart));
        var cartDrawer = new theme.CartDrawer();
        cartDrawer.init();
        cartDrawer.open();
    }


});